<template>
  <v-list dense nav class="px-0">
    <v-list-group color="darkGray">
      <template v-slot:activator>
        <v-list-item>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on"
                  >mdi-playlist-edit</v-icon
                >
              </v-list-item-icon>
            </template>
            <span>Cadastros</span>
          </v-tooltip>
          <v-list-item-title class="ml-n4">Cadastro</v-list-item-title>
        </v-list-item>
      </template>
      <v-divider class="mb-1" />
      <div class="ml-4">
        <v-list-item
          v-for="(admin, i) in itens_cadastro"
          :key="i"
          :href="admin.href"
          target="_blank"
          @click="redirect(admin.way, $event)"
          :class="isActive(admin.way)"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                  admin.icon
                }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ admin.message }}</span>
          </v-tooltip>
          <v-list-item-title class="ml-n6">{{ admin.title }}</v-list-item-title>
        </v-list-item>
      </div>
      <v-divider class="my-1" />
    </v-list-group>

    <v-list-group color="darkGray">
      <template v-slot:activator>
        <v-list-item>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on"
                  >mdi-account-group</v-icon
                >
              </v-list-item-icon>
            </template>
            <span>Grupos</span>
          </v-tooltip>
          <v-list-item-title class="ml-n4">Grupos</v-list-item-title>
        </v-list-item>
      </template>
      <v-divider class="mb-1" />
      <div class="ml-4">
        <v-list-item
          v-for="(admin, i) in itens_grupos"
          :key="i"
          :href="admin.href"
          target="_blank"
          @click="redirect(admin.way, $event)"
          :class="isActive(admin.way)"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                  admin.icon
                }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ admin.message }}</span>
          </v-tooltip>
          <v-list-item-title class="ml-n6">{{ admin.title }}</v-list-item-title>
        </v-list-item>
      </div>
      <v-divider class="my-1" />
    </v-list-group>

    <v-list-group color="darkGray">
      <template v-slot:activator>
        <v-list-item>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on"
                  >mdi-cog</v-icon
                >
              </v-list-item-icon>
            </template>
            <span>Configurações</span>
          </v-tooltip>
          <v-list-item-title class="ml-n4">Configurações</v-list-item-title>
        </v-list-item>
      </template>
      <v-divider class="mb-1" />
      <div class="ml-4">
        <v-list-item
          v-for="(admin, i) in itens_config"
          :key="i"
          :href="admin.href"
          target="_blank"
          @click="redirect(admin.way, $event)"
          :class="isActive(admin.way)"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                  admin.icon
                }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ admin.message }}</span>
          </v-tooltip>
          <v-list-item-title class="ml-n4">{{ admin.title }}</v-list-item-title>
        </v-list-item>
      </div>
      <v-divider class="my-1" />
    </v-list-group>

    <v-list-group color="darkGray">
      <template v-slot:activator>
        <v-list-item>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on"
                  >mdi-clipboard-check-outline</v-icon
                >
              </v-list-item-icon>
            </template>
            <span>Relatórios</span>
          </v-tooltip>
          <v-list-item-title class="ml-n4">Relatórios</v-list-item-title>
        </v-list-item>
      </template>
      <v-divider class="mb-1" />
      <div class="ml-4">
        <v-list-item
          v-for="(admin, i) in itens_relatorios"
          :key="`relatorio_${i}`"
          :href="admin.href"
          target="_blank"
          @click="redirect(admin.way, $event)"
          :class="isActive(admin.way)"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                  admin.icon
                }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ admin.message }}</span>
          </v-tooltip>
          <v-list-item-title class="ml-n4">{{ admin.title }}</v-list-item-title>
        </v-list-item>
      </div>
      <v-divider class="my-1" />
    </v-list-group>

    <v-list-group color="darkGray">
      <template v-slot:activator>
        <v-list-item>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on"
                  >mdi-axis-arrow</v-icon
                >
              </v-list-item-icon>
            </template>
            <span>Rotas</span>
          </v-tooltip>
          <v-list-item-title class="ml-n4">Rotas</v-list-item-title>
        </v-list-item>
      </template>
      <v-divider class="mb-1" />
      <div class="ml-4">
        <v-list-item
          v-for="(admin, i) in itens_cadastro_de_rotas"
          :key="i"
          :href="admin.href"
          target="_blank"
          @click="redirect(admin.way, $event)"
          :class="isActive(admin.way)"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon>
                <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                  admin.icon
                }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ admin.message }}</span>
          </v-tooltip>
          <v-list-item-title class="ml-n6">{{ admin.title }}</v-list-item-title>
        </v-list-item>
      </div>
      <v-divider class="my-1" />
    </v-list-group>

    <div class="px-2">
      <v-list-item
        v-for="(item, i) in itens_avulsos"
        :key="`avulsos_${i}`"
        :href="item.href"
        target="_blank"
        @click="redirect(item.way, $event)"
        :class="isActive(item.way)"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item-icon>
              <v-icon color="bluePcm" v-bind="attrs" v-on="on">{{
                item.icon
              }}</v-icon>
            </v-list-item-icon>
          </template>
          <span>{{ item.message }}</span>
        </v-tooltip>
        <v-list-item-title class="ml-n4">{{ item.title }}</v-list-item-title>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
import { goToSelectedPath } from "@/utils/commomMethods/goToSelectedPath";

export default {
  name: "ListNavigationDrawerPabx",
  props: {
    drawer: Boolean,
  },
  data: () => ({
    rotaSelecionada: "",
    itens_cadastro: [
      {
        title: "Áudios",
        way: "Audios",
        icon: "mdi-file-music",
        message: "Cadastro de Áudio",
        href: "/pabx/cadastro/audios",
      },
      {
        title: "Centros de Custo",
        way: "Centrodecustos",
        icon: "mdi-pin",
        message: "Cadastro de Centro de Custo",
        href: "/pabx/cadastro/centrodecustos",
      },
      {
        title: "Conferências",
        way: "Conferencia",
        icon: "mdi-comment-multiple",
        message: "Cadastro de Conferência",
        href: "/pabx/cadastro/conferencia",
      },
      {
        title: "Grupos de Expressões",
        way: "Aliasregex",
        icon: "mdi-regex",
        message: "Grupo Expressões",
        href: "/pabx/cadastro/aliasregex",
      },
      {
        title: "Músicas de Espera",
        way: "Espera",
        icon: "mdi-folder-music-outline",
        message: "Cadastro Música de Espera",
        href: "/pabx/cadastro/espera",
      },
      {
        title: "Ramais",
        way: "Ramais",
        icon: "mdi-phone",
        message: "Cadastro de Ramal",
        href: "/pabx/cadastro/ramais",
      },
      {
        title: "Tags",
        way: "Tags",
        icon: "mdi-tag-text",
        message: "Cadastro de Tags",
        href: "/pabx/cadastro/tags",
      },
      {
        title: "Troncos",
        way: "Troncos",
        icon: "mdi-hubspot",
        message: "Cadastro de Tronco",
        href: "/pabx/cadastro/troncos",
      },
      {
        title: "URAs",
        way: "Uras",
        icon: "mdi-tournament mdi-rotate-180",
        message: "Cadastro de URA",
        href: "/pabx/cadastro/uras",
      },
    ],
    itens_grupos: [
      {
        title: "Atendimento",
        way: "GruposRamais",
        icon: "mdi-card-account-phone-outline",
        message: "Grupos de Atendimento",
        href: "/pabx/cadastro/gruposramais",
      },
      {
        title: "Captura",
        way: "Grupos",
        icon: "mdi-camera-plus",
        message: "Grupos de Captura",
        href: "/pabx/cadastro/grupos",
      },
    ],
    itens_config: [
      {
        title: "Facilidades",
        way: "Facilidades",
        icon: "mdi-tune-variant",
        message: "Facilidades",
        href: "/pabx/configuracoes/facilidades",
      },
      {
        title: "Firewall",
        icon: "mdi-wall",
        way: "Firewall",
        message: "Firewall",
        href: "/pabx/configuracoes/firewall",
      },
      {
        title: "Geral",
        way: "Geral",
        icon: "mdi-tray-full",
        message: "Geral",
        href: "/pabx/configuracoes/geral",
      },
      {
        title: "Transport",
        way: "Transport",
        icon: "mdi-highway",
        message: "Transport",
        href: "/pabx/configuracoes/transport",
      },
      {
        title: "Sip",
        way: "SipConfig",
        icon: "mdi-tools",
        message: "Sip Configurações",
        href: "/pabx/configuracoes/sipconfig",
      },
      {
        title: "Webhooks",
        way: "Webhooks",
        icon: "mdi-webhook",
        message: "Webhooks",
        href: "/pabx/configuracoes/webhooks",
      },
    ],
    itens_cadastro_de_rotas: [
       {
        title: "Rotas",
        way: "Rotas",
        icon: "mdi-axis-arrow",
        message: "Rotas",
        href: "/pabx/rotas/rotas-pabx",
      },
      {
        title: "Grupo de Rotas",
        way: "GrupoRotas",
        icon: "mdi-account-group",
        message: "Grupo de Rotas",
        href: "/pabx/rotas/grupos-de-rotas"
      }
    ],
    itens_relatorios: [
      {
        title: "Chamadas",
        way: "relatoriochamadas",
        icon: "mdi-phone-log",
        message: "Relatório de Chamadas",
        href: "/pabx/relatorios/chamadas",
      },
      {
        title: "Conferências",
        way: "relatorio-conferencias",
        icon: "mdi-google-classroom",
        message: "Relatório de Conferencias",
        href: "/pabx/relatorios/conferencias",
      },
    ],
    itens_avulsos: [
      {
        title: "Agendamento de Tarefas",
        way: "agendamento",
        icon: "mdi-calendar-check",
        message: "Agendamento de Tarefas",
        href: "/pabx/agendamento",
      },
      {
        title: "Monitor de Ramais",
        way: "monitor",
        icon: "mdi-monitor-eye",
        message: "Monitor de Ramais",
        href: "/pabx/monitor/ramais",
      },
      {
        title: "Integrações",
        way: "integracoes",
        icon: "mdi-cached",
        message: "Integrações",
        href: "/pabx/integracoes",
      },
    ],
  }),

  methods: {
    ...goToSelectedPath,
    isActive(rota) {
      if (rota == this.$route.name) {
        this.rotaSelecionada = rota
        return "indigo lighten-5";
      } else if (rota == this.rotaSelecionada) {
        return "indigo lighten-5";
      }
    },
  },
};
</script>
